<template>
	<div
		:class="{ 'not-supported': !isSupported }"
		class="width-100 display-flex flex-row flex-align-center app-container flex-justify-space-between pr-2"
	>
		<div class="display-flex flex-row flex-align-center">
			<div class="icon-container flex-centerize mr-3">
				<v-img :src="icon" />
			</div>
			{{ name }}
		</div>
		<AppLoader v-if="isLoadingAppRequest" />
		<h3 v-else-if="!isSupported" class="reg request" :class="{ link: !hasRequestedSupport, light: hasRequestedSupport }">
			{{ hasRequestedSupport ? 'Remove Request' : 'Request integration' }}
		</h3>
	</div>
</template>
<script>
export default {
	name: 'AllAppsMenuItem',
	props: {
		icon: { type: String },
		name: { type: String },
		isSupported: { type: Boolean },
		hasRequestedSupport: { type: Boolean },
		isLoadingAppRequest: { type: Boolean },
	},
};
</script>
<style lang="scss" scoped>
.app-container {
	height: 40px;
	cursor: pointer;
	transition: 0.3s;
	border-radius: 10px;
	background: var(--white);
	border: 1px solid #d6ddea;
	&:hover {
		background: #eeeffa;
		box-shadow: 0px 3px 6px var(--shadow-color);
	}
	&:active {
		filter: brightness(0.9);
	}
	&.not-supported {
		background: #f9fafc;
	}
}
.icon-container {
	width: 40px;
	height: 40px;
	padding: 10px;
	border-radius: 10px 0px 0px 10px;
	border-right: 1px solid #d6ddea;
}
.request {
	color: #474647;
}
.light {
	color: #a0a0a2;
}
</style>
